'use client';

import './sac-empty.scss';

import { useTranslation } from 'react-i18next';

import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.js';
import { Link } from '@sola/ark-core/atoms/link/link.js';
import { LogoEmptySearch } from '@sola/ark-core/logos/empty-search.js';
import { FlexibleContentProps } from '@sola/schema/lib/schema.js';

interface SacEmptyProps {
  resetFilters?: () => void;
}
export const SacEmpty: React.FC<FlexibleContentProps & SacEmptyProps> = ({
  resetFilters,
}) => {
  const { t } = useTranslation(['children']);
  return (
    <div className="SacEmpty text-center gap-comfy-lg">
      <div>
        <div className="display-block margin-right-auto margin-left-auto">
          <LogoEmptySearch aria-hidden />
        </div>
        <h2 className="display display-md">{t('children:sac.resetTitle')}</h2>
        <p className="body body-md">{t('children:sac.resetMessage')}</p>
      </div>
      <div className="flex flex-col md:flex-row gap-comfy-xs items-center justify-center">
        <ButtonStyle>
          <button
            onClick={resetFilters}
            className="w-full md:w-fit"
            type="button"
          >
            {t('children:sac.resetFilters')}
          </button>
        </ButtonStyle>
        <ButtonStyle variant="secondary" purpose="neutral">
          <Link href="/sponsor-a-child/child-bio" className="w-full md:w-fit">
            {t('children:sac.selectAChildForMe')}
          </Link>
        </ButtonStyle>
      </div>
    </div>
  );
};
